import type { FC } from 'react'

import { Button } from 'common/components/Button/Button'
import { Input } from 'common/components/Input/Input'
import { Label } from 'common/components/Label/Label'
import { Select } from 'common/components/Select/Select'
import type { PatientStatus } from 'features/Home/interfaces/IInfoSchedule'
import type { AppointmentCategories } from 'features/Schedule/api/schedule.types'

import styles from './ehrAppointmentV2.module.scss'

type Props = {
  patientName: string
  phone: string
  categoryCode: number | string
  statusCode: number | string
  title: string
  categories: AppointmentCategories[]
  statuses: PatientStatus[]
  disabled: boolean
  canPickPatient: boolean
  canAddPatient: boolean
  patientError?: string
  onOpenPatientSearch: () => void
  onAddPatient: () => void
  onCategoryChange: (code: number) => void
  onStatusChange: (code: number) => void
  onTitleChange: (title: string) => void
}

export const IdentityRow: FC<Props> = ({
  patientName,
  phone,
  categoryCode,
  statusCode,
  title,
  categories,
  statuses,
  disabled,
  canPickPatient,
  canAddPatient,
  patientError,
  onOpenPatientSearch,
  onAddPatient,
  onCategoryChange,
  onStatusChange,
  onTitleChange,
}) => (
  <div className={styles.band}>
    <div className={`${styles.field} ${styles.widthPatient}`}>
      <Input
        name='patient_selector'
        label='Patient'
        required
        readOnly
        value={patientName}
        placeholder='Click to select'
        onClick={canPickPatient ? onOpenPatientSearch : undefined}
        error={patientError}
      />
    </div>

    <div className={styles.field}>
      <div className={styles.inline}>
        <div className={styles.widthPhone}>
          <Input name='phone_display' label='Cell Phone' value={phone} readOnly />
        </div>
        {canAddPatient && (
          <Button onClick={onAddPatient} disabled={disabled}>
            New patient
          </Button>
        )}
      </div>
    </div>

    <div className={`${styles.field} ${styles.widthCategory}`}>
      <Select
        label='Category'
        required
        value={categoryCode || undefined}
        disabled={disabled}
        showSearch={false}
        options={categories?.map((category) => ({
          value: category.code,
          label: category.name,
        }))}
        onChange={onCategoryChange}
      />
    </div>

    <div className={`${styles.field} ${styles.widthStatus}`}>
      <Select
        label='Status'
        value={statusCode === '' ? undefined : statusCode}
        disabled={disabled}
        showSearch={false}
        options={statuses?.map((status) => ({ value: status.code, label: status.name }))}
        onChange={onStatusChange}
      />
    </div>

    <div className={`${styles.field} ${styles.fieldTitle}`}>
      <Label label='Title' id='appointment-title' />
      <Input
        name='title'
        id='appointment-title'
        value={title}
        disabled={disabled}
        onChange={(event) => onTitleChange(event.target.value)}
      />
    </div>
  </div>
)
